import { useEffect, useState } from "react";
import styles from "./styles/style.module.scss";
import { Button, input } from "react-bootstrap";
import { getFileBase64 } from "../../../utils/commonFunctions";
import { functionService } from "../../../lib/functions";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ArticleDropdown from "../../../components/elements/articleDropdown";
import { useNavigate } from "react-router-dom";
import imageCompression from 'browser-image-compression';

import * as Styled from "./styled";
import uploadIcon from '../../../images/upload.svg';

const FontFamilyModule = ReactQuill.Quill.import('formats/font');
const FontSize=ReactQuill.Quill.import('attributors/style/size');


FontFamilyModule.whitelist = [
  'monospace',
  'serif',
 'sans-serif',

];

FontSize.whitelist=[
  '26px',
  '20px',
  '18px',
  '16px'
]
ReactQuill.Quill.register(FontSize,true)

ReactQuill.Quill.register(FontFamilyModule, true);

const AddArticles = () => {
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [articleType, setArticleType] = useState("");
  const [articleTitle, setArticleTitle] = useState("");
  const [description, setDescription] = useState("");
  const [hashTags, setHashTags] = useState([]);
  const [coverImage, setCoverImage] = useState();
  const [base64Images, setbase64Images] = useState();
  const [active, setactive] = useState(true);
  const [postData, setPostData] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [articleMetaTitle, setArticleMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [keywords, setMetaKeywords] = useState([]);
  const navigate = useNavigate();
  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "color",
    "background",
    "link",
    "image",
  ];
  const modules = {
    toolbar: [
      [{ header: [3,'4']},{ header: 1},{ header: 2}  ],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ font: FontFamilyModule.whitelist }],
      [{ size: FontSize.sizes }],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      [
        {
          color: [
            "#000000",
            "#e60000",
            "#ff9900",
            "#ffff00",
            "#008a00",
            "#0066cc",
            "#9933ff",
            "#ffffff",
            "#facccc",
            "#ffebcc",
            "#ffffcc",
            "#cce8cc",
            "#cce0f5",
            "#ebd6ff",
            "#bbbbbb",
            "#f06666",
            "#ffc266",
            "#ffff66",
            "#66b966",
            "#66a3e0",
            "#c285ff",
            "#888888",
            "#a10000",
            "#b26b00",
            "#b2b200",
            "#006100",
            "#0047b2",
            "#6b24b2",
            "#444444",
            "#5c0000",
            "#663d00",
            "#666600",
            "#003700",
            "#002966",
            "#3d1466",
          ],
        },
        {
          background: [
            "#000000",
            "#e60000",
            "#ff9900",
            "#ffff00",
            "#008a00",
            "#0066cc",
            "#9933ff",
            "#ffffff",
            "#facccc",
            "#ffebcc",
            "#ffffcc",
            "#cce8cc",
            "#cce0f5",
            "#ebd6ff",
            "#bbbbbb",
            "#f06666",
            "#ffc266",
            "#ffff66",
            "#66b966",
            "#66a3e0",
            "#c285ff",
            "#888888",
            "#a10000",
            "#b26b00",
            "#b2b200",
            "#006100",
            "#0047b2",
            "#6b24b2",
            "#444444",
            "#5c0000",
            "#663d00",
            "#666600",
            "#003700",
            "#002966",
            "#3d1466",
          ],
        },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  useEffect(() => {
  functionService.get('article/getArticleCategories')
    .then(response => setCategories(response.response.data.data));
  },[]);

  function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

  const checkFields = async () => {
    let errorArr = [];
    let errorStatus = false;
    if (
      coverImage == undefined ||
      coverImage == null ||
      coverImage == "undefined" ||
      coverImage == "null"
    ) {
      errorArr.push("Article Image");
      errorStatus = true;
    }
    if (
      articleTitle == undefined ||
      articleTitle == null ||
      articleTitle == "undefined" ||
      articleTitle == "null" ||
      articleTitle.trim().length == 0
    ) {
      errorArr.push("Article Title");
      errorStatus = true;
    }
    if (
      description == undefined ||
      description == null ||
      description == "undefined" ||
      description == "null" ||
      description.trim().length == 0
    ) {
      errorArr.push("Article Description");
      errorStatus = true;
    }
    if (
      hashTags == undefined ||
      hashTags == null ||
      hashTags == "undefined" ||
      hashTags == "null" ||
      hashTags.length == 0
    ) {
      errorArr.push("Article Hashtags");
      errorStatus = true;
    }
    if (
      postData == undefined ||
      postData == null ||
      postData == "undefined" ||
      postData == "null" ||
      postData.trim().length == 0
    ) {
      errorArr.push("Article Post Data");
      errorStatus = true;
    }
    if (
      keywords == undefined ||
      keywords == null ||
      keywords == "undefined" ||
      keywords == "null" ||
      keywords.length == 0
    ) {
      errorArr.push("Article keywords");
      errorStatus = true;
    }
    if (
      metaDescription == undefined ||
      metaDescription == null ||
      metaDescription == "undefined" ||
      metaDescription == "null" ||
      metaDescription.length == 0
    ) {
      errorArr.push("Article meta description");
      errorStatus = true;
    }
    if (
      articleMetaTitle == undefined ||
      articleMetaTitle == null ||
      articleMetaTitle == "undefined" ||
      articleMetaTitle == "null" ||
      articleMetaTitle.length == 0
    ) {
      errorArr.push("Article meta title");
      errorStatus = true;
    }
    if (errorStatus == false) {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      }
    ;
      const compressedFile = (await imageCompression(base64Images, options));
      const image=await blobToBase64(compressedFile)

      let payload = {
        articleTitle: articleTitle,
        description: description,
        hashTags: hashTags,
        imagePayload: image,
        postData: postData,
        active: active,
        category: category,
        type: articleType,
        articleMetaTitle,
        metaDescription,
        keywords
      };
      const { status } = await functionService.post(
        "article/addArticle",
        payload
      );
      // console.log(status)
      if (status) {
        // redirect
        navigate('/articles')
      }
    } else {
      setErrorMsg(errorArr.join(", "));
    }
  };

  const handleCategoryChange = (item) => {
    setCategory(item);
  }

  const handleTypeChange = (item) => {
    setArticleType(item);
  }

  const coverImageHandler = (e) => {
    const image = e.target.files[0];
    setbase64Images(image);
    const fileExtension = image.name.split('.')[1];
    if (fileExtension === 'png' || fileExtension === 'jpeg' || fileExtension === 'jpg') {
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        setCoverImage(fileReader.result);

        setErrorMsg('');
        // error.cover_image = '';
        // this.setState({ error });
        // this.setState({ test });
      }, false);
      fileReader.readAsDataURL(image);
    } else {
      setErrorMsg('Upload File In Required Format!');
      setCoverImage(null);
      // test.cover_image = null;
      // this.setState({ error });
      // this.setState({ test });
    }
  }

  const hashInput = (e) => {
    let hashInputArr = e.split(",");
    for (var i = 0; i < hashInputArr.length; i++) {
      hashInputArr[i] = hashInputArr[i].trim();
    }
    setHashTags(hashInputArr);
  };
  const metaKeywordsInput=(e)=>{
    let keywordsArr = e.split(',')
    for (var i = 0; i < keywordsArr.length; i++) {
      keywordsArr[i] = keywordsArr[i].trim();
    }
    setMetaKeywords(keywordsArr);
  }
  return (
    <Styled.ColumnDiv>
        <Styled.ContentWrapDiv style={{margin: '0', height: 'calc(100vh - 20px)'}}>
          <Styled.ContentDiv>
            <Styled.CardDiv>
                {errorMsg.trim().length > 0 && (
                  <div className="alert alert-danger  alert-dismissible fade show">
                    Please add {errorMsg}
                  </div>
                )}

                  <Styled.EditHeaderWrapDiv>
                    <div>Add Article</div>
                    <p>Edit and publish the articles from here.</p>
                  </Styled.EditHeaderWrapDiv>
                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>
                      Category
                    </Styled.InputTitleDiv>
                    <ArticleDropdown
                    title="Categories"
                    list={categories}
                    value="id"
                    name="category"
                    selected={handleCategoryChange}
                    width="180px"
                    option="name"
                    active={category}
                    addAll
                    />
                  </Styled.InputWrap>
                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>
                      Article Type
                    </Styled.InputTitleDiv>
                    <ArticleDropdown
                    title="Type"
                    list={[{title: "Article"}, {title: 'Blog'}]}
                    value="id"
                    name="category_type"
                    selected={handleTypeChange}
                    width="180px"
                    option="title"
                    active={articleType}
                    addAll
                    />
                  </Styled.InputWrap>
                {/* <div className="row"> */}
                  <Styled.InputWrap>
                      <Styled.InputTitleDiv>
                        Article Title
                      </Styled.InputTitleDiv>
                      <input
                        className="form-control"
                        placeholder="Enter article title here."
                        type="text"
                        name="title"
                        value={articleTitle}
                        onChange={(e) => setArticleTitle(e.target.value)}
                      />
                  </Styled.InputWrap>

                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>
                      Description
                    </Styled.InputTitleDiv>


                    <textarea
                      className="form-control"
                      type="text"
                      placeholder="Enter article description here."
                      name="description"
                      rows="8"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Styled.InputWrap>
                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>
                      Hashtags
                    </Styled.InputTitleDiv>
                    <input
                      className="form-control"
                      placeholder="Give a hastag for your article."
                      type="text"
                      name="title"
                      value={hashTags}
                      onChange={(e) => hashInput(e.target.value)}
                    />
                  </Styled.InputWrap>

                  <Styled.InputWrap>
                      <Styled.MetaTitle>
                        Meta Title
                      </Styled.MetaTitle>
                      <input
                        className="form-control"
                        placeholder="Enter article meta title here."
                        type="text"
                        name="meta_title"
                        value={articleMetaTitle}
                        onChange={(e) => setArticleMetaTitle(e.target.value)}
                      />
                  </Styled.InputWrap>

                  <Styled.InputWrap>
                      <Styled.MetaTitle>
                        Meta Description
                      </Styled.MetaTitle>
                      <textarea
                        className="form-control"
                        type="text"
                        placeholder="Enter article description here."
                        name="meta_description"
                        rows="8"
                        value={metaDescription}
                        onChange={(e) => setMetaDescription(e.target.value)}
                      />
                  </Styled.InputWrap>

                  <Styled.InputWrap>
                      <Styled.MetaTitle>
                        Meta Keywords
                      </Styled.MetaTitle>
                      <input
                        className="form-control"
                        placeholder="Enter article meta keywords here."
                        type="text"
                        name="meta_keyword"
                        value={keywords}
                        onChange={(e) => metaKeywordsInput(e.target.value)}
                      />
                  </Styled.InputWrap>

                  {/* <div className={styles.input}>
                    <Styled.InputTitleDiv>
                      Upload Article Image
                    </Styled.InputTitleDiv>
                    <input
                      className="form-control form-control-sm"
                      id="formFileSm"
                      type="file"
                      accept=".jpg,.jpeg,.png"
                      onChange={(e) => setCoverImage(e.target.files[0])}
                    />
                  </div> */}

                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>Upload Cover Image</Styled.InputTitleDiv>
                    <Styled.CoverImageWrapDiv>
                      <div style={{ fontSize: '16px', marginBottom: '8px' }}>Upload Cover Image</div>
                      <div style={{ opacity: '0.6', marginBottom: '4px' }}>Image size: 650x861</div>
                      <div style={{ opacity: '0.6', marginBottom: '15px' }}>Image formats (PNG, JPEG or JPG)</div>

                      { coverImage &&
                        <img src={coverImage} style={{width: '100px', height: '100px', margin: '0 auto 15px'}} />
                      }

                      {/* { error.cover_image &&
                        <Styled.SaveErrorDiv style={{marginBottom: '15px'}}>{error.cover_image}</Styled.SaveErrorDiv>
                      } */}

                      <Styled.CoverImageLabel htmlFor='cover-image'>
                        <img src={uploadIcon} alt=''/>Upload Cover
                        <Styled.CoverImageInput
                          id='cover-image'
                          type='file'
                          accept='image/png, image/jpeg, image/jpg'
                          onChange={coverImageHandler}
                          name='cover_image'
                        />
                      </Styled.CoverImageLabel>
                    </Styled.CoverImageWrapDiv>
                    <Styled.InputErrorDiv></Styled.InputErrorDiv>
                  </Styled.InputWrap>

                  <Styled.InputWrap>
                    <Styled.InputTitleDiv>
                      Write the Post
                    </Styled.InputTitleDiv>
                  </Styled.InputWrap>
                  <Styled.EditorWrap>
                  <ReactQuill
                      theme="snow"
                      value={postData}
                      modules={modules}
                      formats={formats}
                      style={{ height: "300px" }}
                      placeholder="Write you article content here."
                      onChange={(e) => setPostData(e)}
                    />
                  </Styled.EditorWrap>
                {/* </div> */}
                  <Styled.SaveWrapDiv>
                  <a href='/articles' style={{textDecoration: 'none'}}><Styled.SaveButton>Cancel</Styled.SaveButton></a>
                  <Styled.SaveButton onClick={() => checkFields()}>Save & Publish</Styled.SaveButton>
                  </Styled.SaveWrapDiv>
            </Styled.CardDiv>
          </Styled.ContentDiv>
        </Styled.ContentWrapDiv>
      </Styled.ColumnDiv>
  );
};

export default AddArticles;
